module.exports = __webpack_public_path__ + "img/introduction-ilustra.eb1b0d9b.png";